import type { CSSProperties } from 'react';

import type { WebBranding } from '~/lib/tenant/web-branding.schema';

import { contrastForeground, landingThemeStyle } from '../landing/landing-design';

export function brandingChromeStyle(appearance?: WebBranding['header'], menu = false): CSSProperties | undefined {
  if (!appearance || !Object.values(appearance).some((value) => value !== undefined)) return undefined;
  const backgroundColor = (menu ? appearance.menuBackgroundColor : undefined) ?? appearance.backgroundColor;
  const color = (menu ? appearance.menuTextColor ?? (appearance.menuBackgroundColor ? contrastForeground(appearance.menuBackgroundColor) : undefined) : undefined) ?? appearance.textColor ?? (backgroundColor ? contrastForeground(backgroundColor) : undefined);
  const typography = appearance.fontFamily ? landingThemeStyle({ fontFamily: appearance.fontFamily }) : undefined;
  return {
    backgroundColor: backgroundColor ?? (!menu || appearance.textColor || appearance.menuTextColor ? 'var(--primary, #1C1C1C)' : undefined),
    color,
    ...(typography ? { fontFamily: typography['--landing-heading-font'] ?? typography.fontFamily } : {}),
  };
}
